module.exports = __webpack_public_path__ + "assets/img/video-btn-ad9d86c3.png";